//people reducer types
export const LOADING_COMPANY = "LOADING_COMPANY";
export const LOAD_COMPANY = "LOAD_COMPANY";
export const COMPANY_SAVE_REQUEST = "COMPANY_SAVE_REQUEST";
export const COMPANY_SAVE_SUCCESS = "COMPANY_SAVE_SUCCESS";
export const FETCH_COMPANY_REQUEST = "FETCH_COMPANY_REQUEST";
export const FETCH_COMPANY_REQUEST_SUCCESS = "FETCH_COMPANY_REQUEST_SUCCESS";
